import * as React from "react";
import { connect } from "react-redux";
import { Tabs, Tab } from "react-bootstrap";
import { bindActionCreators } from "redux";
import IDraftRegistrationProps from "./IDraftRegistration";
import constantFile from "../../constants/constantFile";
import { IS_EDITABLE_WARRANTY } from "../../constants/storageKeys";
import { dateFormatter, dateTimeFormatter, imagePathurl, setSessionValue } from "../../utils/utils";
import "../../../assets/sass/components/draftRegistration.scss";
import * as DRAFT_LIST_ACTIONS from "./actionCreators";
import * as globalActionsCreator from "../../globalStore/actions";
import * as dynamicFormActionsCreator from "../../components/DynamicForm/actionCreators";
import * as SUBMITTED_LIST_ACTIONS from "../SubmittedWarranties/actionCreators";
import * as myCartActionCreator from "../MyCart/actionCreators";

import ReactGA from "react-ga";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const Loadable = require("react-loadable");

const BSTable = Loadable({
    loader: () => import("../BSTable"),
    loading() {
        return <div>Loading...</div>;
    },
});

const SubmittedWarranties = Loadable({
    loader: () => import("../SubmittedWarranties"),
    loading() {
        return <div>Loading...</div>;
    },
});

interface IDraftStateProps {
    deleteObj: any;
    activeTab: string;
    addToCartClicked: boolean;
}
/**
 * @category Main Component
 * @description This component uses BSTable component to render the draft list
 */
class DraftRegistration extends React.Component<IDraftRegistrationProps, IDraftStateProps, {}> {
    constructor(props) {
        super(props);
        this.state = {
            deleteObj: {},
            activeTab: "draft",
            addToCartClicked: false,
        };
        this.dateSortFunc = this.dateSortFunc.bind(this);
        this.rankFormatter = this.rankFormatter.bind(this);
        this.onTableRowClick = this.onTableRowClick.bind(this);
        this.onTableRowDelete = this.onTableRowDelete.bind(this);
        this.prepareTableData = this.prepareTableData.bind(this);
        this.onDeleteRowConfirm = this.onDeleteRowConfirm.bind(this);
        this.ownerSortFunc = this.ownerSortFunc.bind(this);
    }
    componentDidUpdate(prevProps, prevState) {
        const { deletePopupContent: oldDeletePopupContent } = prevProps;
        const {
            deletePopupContent: newDeletePopupContent,
            isLayoutCallInProcess,
            clickIDList,
            deleteDraftID,
            isLoading,
            cartId,
            isSuccess,
            message,
            draftListActions: { addClickElements, fetchDraftWarrentyList },
        } = this.props;
        if (
            oldDeletePopupContent.showPopup !== newDeletePopupContent.showPopup &&
            oldDeletePopupContent.confirm !== newDeletePopupContent.confirm
        ) {
            this.onDeleteRowConfirm(this.state.deleteObj);
        }
        if (prevProps.deleteDraftID !== deleteDraftID) {
            this.setState({ deleteObj: {} });
        }
        if (!isLayoutCallInProcess && clickIDList.length > 0) {
            if (document.getElementsByClassName(clickIDList[clickIDList.length - 1])[0]) {
                const element: HTMLElement = document.getElementsByClassName(
                    clickIDList[clickIDList.length - 1]
                )[0] as HTMLElement;
                element.click();
            }
            addClickElements("");
        }
        if (this.state.addToCartClicked && !isLoading && !!cartId && isSuccess) {
            this.setState({
                addToCartClicked: false,
            });
            fetchDraftWarrentyList();
            this.props.globalActions.showGlobalSuccssMsg(message);
        }
    }
    componentWillUnmount(): void {
        this.setState({
            addToCartClicked: false,
        });
    }
    copyWarranty = () => {
        const {
            globalActions: { updateActiveScreen },
        } = this.props;
        updateActiveScreen("NewForm");
    };
    handleSelectTab = (tab) => {
        const { updateActiveTab } = this.props.submittedListActions;
        this.setState({
            activeTab: tab,
        });
        setSessionValue(IS_EDITABLE_WARRANTY, false);
        updateActiveTab(tab);
    };
    rankFormatter(cell, row, rowIndex) {
        return (
            <div
                id={`delete-row-${row.id}`}
                className="draft-actions"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                {row.isCartReady && (
                    <div className="add-to-cart-img" title="Add To Cart">
                        <a onClick={() => this.addToCartWarranty(row)}></a>
                    </div>
                )}
                <div className="delete-row-img" title="Delete">
                    <a onClick={() => this.onTableRowDelete(row)}></a>
                </div>
            </div>
        );
    }
    addToCartWarranty = (obj) => {
        console.log("Add To Cart Clicked", obj);
        const { myCartActions, cartId } = this.props;
        // implement add to cart function and redirect to cart view page
        !!cartId
            ? myCartActions.addCartItem({ warrantyId: obj.id, cartId })
            : myCartActions.createShoppingCart({ warrantyId: obj.id });
        this.setState({
            addToCartClicked: true,
        });
    };
    onTableRowClick(obj) {
        window["AppInsightTrace"].trackEvent(`On draft selection`);
        const { onTableRowSelection } = this.props;
        
        // Removing isVarianceRequested entry on row click.
        if(sessionStorage.getItem('isVarianceRequested')) {
            sessionStorage.removeItem('isVarianceRequested');
        }
        if (sessionStorage.getItem('continueAsAdminForError')) {
            sessionStorage.removeItem('continueAsAdminForError');
        }
        
        if (!this.props.isLayoutCallInProcess) {
            onTableRowSelection(obj.id, obj.forminstanceTypeId);
            ReactGA.event({
                category: "Form Access",
                action: "Dashboard: Recent Form Selected",
                label: `Dashboard: Recent Form Selected: ${obj.id}`,
            });
            this.props.dynamicFormActions.updateFormType(true);
        } else this.props.draftListActions.addClickElements(`table-row-id-${obj.id}`);
    }

    onTableRowDelete(obj) {
        const object = {
            title: constantFile.deleteGeneralTitle,
            description: "",
            buttonText: constantFile.deleteDraftButtonText,
            showPopup: true,
            confirm: false,
        };
        this.props.draftListActions.updateDeletePopup({ payload: object });
        this.setState({ deleteObj: obj });
        document.body.classList.add("hideOverflow");
        window["AppInsightTrace"].trackEvent(`On delete draft icon click`);
    }
    onDeleteRowConfirm(obj) {
        const successCallBack = (data) => {
            window["AppInsightTrace"].trackTrace(`On delete draft icon click confirmation: Successcall`);
            ReactGA.event({
                category: "Form Access",
                action: "Dashboard: Delete",
                label: `Dashboard: Delete: ${data.id}: ${dateTimeFormatter(new Date())}`,
            });
        };
        const failureCallback = (data) => {
            let commonErrorMsg = "";
            window["AppInsightTrace"].trackTrace(`unsuccessful delete draft`);
            if (data && data.response && data.response.data && data.response.data.Message) {
                commonErrorMsg = data.response.data.Message;
                window["AppInsightTrace"].trackException(`On delete row error message:  ${commonErrorMsg} `);
            } else {
                const globalErrorMsg = this.props.globalActions.showGlobalError(
                    (data && data.response && data.response.data) || ""
                );
                commonErrorMsg = globalErrorMsg.payload.errorMessage;
                window["AppInsightTrace"].trackException(`On delete row global error message:  ${commonErrorMsg} `);
            }
            ReactGA.event({
                category: "Error",
                action: `Error: ${commonErrorMsg}`,
                label: `Error: ${commonErrorMsg}`,
            });
        };
        const { deleteDraftWarrentyItem, updateDeletePopup } = this.props.draftListActions;
        deleteDraftWarrentyItem({
            payload: { Id: obj.id, successCallBack: successCallBack, failureCallback: failureCallback },
        });
        const object = {
            title: "",
            description: "",
            buttonText: "",
            showPopup: false,
            confirm: false,
        };
        updateDeletePopup({ payload: object });
        this.setState({ deleteObj: {} });
    }

    // date and time sort function for create and update
    dateSortFunc(a, b, order, dataField, rowA, rowB) {
        const updateDateTime = {};
        window["AppInsightTrace"].trackEvent(`clicked on date and time sort`);
        this.props.tableData.map((draftItem) => {
            updateDateTime[draftItem.id] = draftItem.updatedDate;
        });
        return updateDateTime[b.id];
    }

    // Sort the owner column using lastName+firstName
    ownerSortFunc(a, b) {
        const updateOwnerInfo = {};
        this.props.tableData.map((draftItem) => {
            updateOwnerInfo[draftItem.id] = draftItem.owner ? draftItem.owner.lastName + draftItem.owner.firstName : "";
        });
        return updateOwnerInfo[b.id];
    }

    prepareTableData(tableRecords) {
        const BSTableData = [];
        tableRecords
            .sort((a, b) => {
                const dateA: any = new Date(a.updatedDate);
                const dateB: any = new Date(b.updatedDate);
                return dateB - dateA;
            })
            .forEach((draftItem) => {
                const newItem = {};
                newItem["id"] = draftItem.id;
                newItem["isCartReady"] = draftItem.isCartReady;
                const seperator = draftItem.owner && draftItem.owner.lastName && draftItem.owner.firstName ? ", " : "";
                newItem["buildingAddress"] = draftItem.buildingAddress.addressLine1;
                newItem["owner"] = draftItem.owner
                    ? draftItem.owner.lastName + seperator + draftItem.owner.firstName
                    : "";
                newItem["region"] = draftItem.buildingAddress
                    ? draftItem.buildingAddress.city + ", " + draftItem.buildingAddress.state
                    : "";
                newItem["warrantyType"] = draftItem.warrantyType;
                newItem["forminstanceTypeId"] = draftItem.forminstanceTypeId;
                newItem["date"] = dateFormatter(draftItem.updatedDate);
                newItem["delete"] = "delete";
                BSTableData.push(newItem);
            });
        return BSTableData;
    }

    createNew = () => {
        const {
            onCreateNew,
            isLayoutCallInProcess,
            draftListActions: { addClickElements },
        } = this.props;
        if (!isLayoutCallInProcess) {
            onCreateNew();
        } else addClickElements("create-new");
        
        // Removing isVarianceRequested entry on row click.
        if (sessionStorage.getItem('isVarianceRequested')) {
            sessionStorage.removeItem('isVarianceRequested');
        }
        if (sessionStorage.getItem('continueAsAdminForError')) {
            sessionStorage.removeItem('continueAsAdminForError');
        }
    };

    render() {
        constantFile.draftTableColumns[5]["formatter"] = this.rankFormatter;
        constantFile.draftTableColumns[4]["sortValue"] = this.dateSortFunc;
        constantFile.draftTableColumns[3]["sortValue"] = this.ownerSortFunc;

        const tableColumns = constantFile.draftTableColumns;
        const defaultSorted = constantFile.draftTableDefaultSorted;

        const { tableData, isDeleteFlag } = this.props;

        const BSTableData = this.prepareTableData(tableData);
        //image CDN_PATH
        const getimagePath = imagePathurl();
        const displayClass = BSTableData.length === 0 ? "invisible" : "visible";
        const containerClass = "residential-waranty-Draft-Container";
        // this.state.activeTab === "submitted" && BSTableData.length > 0
        //     ? "residential-waranty-submitted-Container"
        //     : "residential-waranty-Draft-Container";
        return (
            <React.Fragment>
                {/* show draft container with drafts or when the last draft is deleted */}
                {(tableData.length >= 0 || isDeleteFlag) && (
                    <div className={containerClass}>
                        <div>
                            <div className="form-header d-flex">
                                <div className="flex-column">
                                    <div className="form-title">Residential Warranty Registration Dashboard</div>
                                </div>
                                <div className="form-btn d-flex">
                                    <div className="form-btn">
                                        <button
                                            type="button"
                                            tabIndex={10}
                                            id="create-new-button"
                                            className="create-new"
                                            onClick={this.createNew}
                                        >
                                            Create New
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="warranty-list">
                                <Tabs activeKey={this.props.activeTab} className="mb-3" onSelect={this.handleSelectTab}>
                                    <Tab eventKey="draft" title="Draft Warranties">
                                        <div className="form-subtitle">
                                            {BSTableData.length === 0
                                                ? "We are sorry, but you have removed all of your drafts. Please click “Create New” to start a new registration form."
                                                : `You have ${BSTableData.length} saved forms. Select an item to open the form.`}
                                        </div>
                                        <div className={displayClass}>
                                            <div>
                                                {this.props.screenResolution.width >= 768 && (
                                                    <div>
                                                        <BSTable
                                                            hover
                                                            striped
                                                            sortable
                                                            bordered={false}
                                                            defaultSorted={defaultSorted}
                                                            tableColumnData={tableColumns}
                                                            tableRowData={BSTableData}
                                                            tableRowClick={this.onTableRowClick}
                                                            tableRowDelete={this.onTableRowDelete}
                                                        />
                                                    </div>
                                                )}
                                                {this.props.screenResolution.width < 768 && (
                                                    <div>
                                                        <div className="item-list">
                                                            {BSTableData.map((tableItem, index) => {
                                                                return (
                                                                    <div
                                                                        id={`table-row-id-${tableItem.id}`}
                                                                        key={`menuitem${index}`}
                                                                        className={`item d-flex menu-item table-row-id-${tableItem.id}`}
                                                                        onClick={() => this.onTableRowClick(tableItem)}
                                                                    >
                                                                        <div className="flex-coloumn w-100">
                                                                            <div className="address">
                                                                                {tableItem.buildingAddress}
                                                                            </div>
                                                                            <div className="date">
                                                                                {dateFormatter(tableItem.date)}
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            className="delete-btn-menu"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                            }}
                                                                        >
                                                                            {tableItem.isCartReady && (
                                                                                <img
                                                                                    className="add-to-cart-item"
                                                                                    src={`${getimagePath}CartAddRed.svg`}
                                                                                    alt="add to cart"
                                                                                    onClick={() => {
                                                                                        this.addToCartWarranty(
                                                                                            tableItem
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            )}
                                                                            &nbsp;
                                                                            <img
                                                                                className="delete-item"
                                                                                src={`${getimagePath}trash.svg`}
                                                                                alt="delete"
                                                                                onClick={() => {
                                                                                    this.onTableRowDelete(tableItem);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="submitted" title="Submitted Warranties">
                                        <SubmittedWarranties copyWarranty={this.copyWarranty} />
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export function mapStateToProps(state) {
    return {
        deleteDraftID: state.draftListInfo.deleteItem,
        userInfo: state.adminData.userInfo,
        deletePopupContent: state.draftListInfo.deletePopup,
        screenResolution: state.globalInfo.screenResolution,
        activeTab: state.submittedListInfo.activeTab,
        isLayoutCallInProcess: state.dynamicFormInfo.isLayoutCallInProcess,
        clickIDList: state.draftListInfo.clickIds,
        isLoading: state.myCartInfo.isLoading,
        isSuccess: state.myCartInfo.success,
        cartId: state.myCartInfo.cartId,
        message: state.myCartInfo.successMsg,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        draftListActions: bindActionCreators(DRAFT_LIST_ACTIONS, dispatch),
        globalActions: bindActionCreators(globalActionsCreator, dispatch),
        dynamicFormActions: bindActionCreators(dynamicFormActionsCreator, dispatch),
        myCartActions: bindActionCreators(myCartActionCreator, dispatch),
        submittedListActions: bindActionCreators(SUBMITTED_LIST_ACTIONS, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DraftRegistration);
